<template>
  <div class="devices container">

    <!-- ------------------------------- Modal: Add/Modify Devices ------------------------------------------ -->

    <div>
		<CModal title="Device Details" color="info" :show.sync="deviceModal" size="lg">		  
			<div slot="footer">
				<button class="btn btn-info" v-on:click.prevent="serverCall('saveDevice')">Save</button>
				<button class="btn btn-info ml-2" v-on:click.prevent="deviceModal=false">Close</button>
			</div>

			<form>

				<div class="form-group row">
					<label for="name" class="col-sm-2 col-form-label text-right">Name</label>
					<div class="col-sm-6">
						<input type="text" id="name" class="form-control"
								v-model="device.name">
					</div>
					<label for="activeFlag" class="col-sm-1 col-form-label text-right">Active?</label>
					<div class="col-sm-3">
						<select class="form-control" v-model="device.activeFlag">
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
					</div>
				</div>

				<div class="form-group row">
					<label for="deviceId" class="col-sm-2 col-form-label text-right">Device ID</label>
					<div class="col-sm-10">
						<input type="text" id="deviceId" class="form-control" 
								v-model="device.deviceId" required="">
					</div>
				</div>

				<div class="form-group row">
					<label for="authKey" class="col-sm-2 col-form-label text-right">AuthKey</label>
					<div class="col-sm-10">
						<input type="text" id="authKey" class="form-control" 
								v-model="device.authKey" required="">
					</div>
				</div>

				<div class="form-group row">
					<label for="phone" class="col-sm-2 col-form-label text-right">Phone</label>
					<div class="col-sm-4">
						<input type="text" id="phone" class="form-control" 
								v-model="device.phone" required="">
					</div>
				</div>

				<p class="text-danger" align="left">{{deviceAlert}}</p>
			</form>

		</CModal>
	</div>


    <!-- ---------------------------------------  Device List -------------------------------------------------- -->

	<vue-good-table ref="devicesTable" :columns="colDevices" :rows="rowDevices" 
							@on-row-click="rowChanged" 
							:selectOptions="{
									enabled: true,
									selectOnCheckboxOnly: false, 
							}">
			<div slot="table-actions">
				<CButton  class="ml-2 mr-3" color="primary" v-on:click.prevent="openNewDeviceDetails()">
					Add
				</CButton>
			</div>
			<div slot="selected-row-actions">
				<CButton color="info" v-on:click.prevent="openExistingDeviceDetails()">
					Modify
				</CButton>
				<CButton class="ml-2" color="info" v-on:click.prevent="serverCall('deleteDevice')">
					Delete
				</CButton>
			</div>
	</vue-good-table>

	<p class="text-danger" align="left">{{alert}}</p>

	<main id="main">
	</main>

  </div>
</template>

<script>
import axios from "axios"
import { firebase } from '@firebase/app'
import "firebase/auth"

export default {
	name: 'devices',

    components: {
		},
		
	data () {
		return {
			alert: '',
			deviceAlert: '',

			deviceModal: false,

			deviceSelected: {'id': '', 'name': ''},

			devices: [],

			device: {
					deviceDocId: '',
					name: '',
					activeFlag: '',
					authKey: '',
					phone: '',
					deviceId: '',
					regDate: ''
			},

			colDevices: [
					{
							label: 'Name',
							field: 'name',
							html: false,
							filterOptions: {enabled: true,},
					},
					{
							label: 'Active?',
							field: 'activeFlag',
							html: false
					},
					{
							label: 'Device ID',
							field: 'deviceId',
							html: false,
							filterOptions: {enabled: true,},
					},
					{
							label: 'AuthKey',
							field: 'authKey',
							html: false
					},
					{
							label: 'Reg Date',
							field: 'regDate',
							html: false
					},
					{
							label: 'Phone',
							field: 'phone',
							html: true
					},
			],

			rowDevices: [],
			curRowSelected: null,	
		}
	},

	computed: {
	},

	mounted(){
		this.serverCall('getDevices')	
	},

	methods: {
        serverCall(name) {
            var self = this
			self.alert = null

			firebase.auth().onAuthStateChanged(user => {
				if (user) {
					user.getIdToken(true).then(idToken => {
						var org = self.getUserOrg()
						switch(name) {
							case "getDevices":
								self.getDevices(idToken, org)
								break;
							case "saveDevice":
								self.saveDevice(idToken, org)
								break;
							case "deleteDevice":
								self.deleteDevice(idToken, org)
								break;
							default:
								console.log("Unknown function: " + name)
						}
					})
				}
				else {
					self.alert = "Please login first."
				}
			})
		},

        // Fetch devices for the given org
        getDevices(authToken, org) {
            var self = this
			self.alert = null

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/GetDevices/',
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data',
					},
				})
				.then(function (response) {
					if (response.data.err != ''){
						self.alert = response.data.err
					}
					else {
						self.rowDevices = response.data.deviceList
					}
				})
				.catch(function (error) {
					self.alert = String(error)
				})	
		},

		rowChanged(params){	
			// Current selected Row
			if (this.curRowSelected != null){
				// If new row is not same as previous row, uncheck previous row
				if (this.curRowSelected.originalIndex!=params.row.originalIndex)
					this.curRowSelected.vgtSelected = false
			}
			// New selected row
			this.curRowSelected = params.row
		},

		// Open details for existing device
		openExistingDeviceDetails(){
            var self = this
			self.alert = null

            // Check if Device is selected
			if (self.curRowSelected==null){
				self.alert = "Device not selected."
				return
			}

			// Initialize device object
			self.device.deviceDocId = self.curRowSelected.deviceDocId
			self.device.name = self.curRowSelected.name
			self.device.activeFlag = self.curRowSelected.activeFlag
			self.device.deviceId = self.curRowSelected.deviceId
			self.device.authKey = self.curRowSelected.authKey
			self.device.phone = self.curRowSelected.phone

			// Show modal with device values
			//$('#deviceDetailsModal').modal('show')
			this.deviceModal = true
		},

		// Open details for new device
		openNewDeviceDetails(){
            var self = this
			self.alert = null

			// Initialize device object
			self.device.deviceDocId = ''
			self.device.name = ''
			self.device.activeFlag = "Yes"
			self.device.deviceId = ''
			self.device.authKey = ''
			self.device.phone = ''

			// Show modal with device values
			//$('#deviceDetailsModal').modal('show')
			this.deviceModal = true
		},

		// Save device changes for new as well as existing devices
        saveDevice(authToken, org) {
            var self = this
            this.deviceAlert = ""

            if (!self.device.name) {
                self.deviceAlert= 'Device name not specified.'
                return
            }
            if (!self.device.deviceId) {
                self.deviceAlert = 'Device ID not specified.'
                return
            }

			var formData = new FormData();
			formData.append("deviceDocId", self.device.deviceDocId);
			formData.append("name", self.device.name);
			formData.append("activeFlag", self.device.activeFlag);
			formData.append("deviceId", self.device.deviceId);
			formData.append("authKey", self.device.authKey);
			formData.append("phone", self.device.phone);

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/SaveDevice/',
					data: formData,
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if (response.data.err != '') {
						self.deviceAlert = response.data.err
					}
					else {
						// Refresh device list on the screen
						self.serverCall('getDevices')							
						//$('#deviceDetailsModal').modal('hide')
						self.deviceModal = false
					}
				})
				.catch(function (error) {
					self.deviceAlert = String(error)
				})
		},

		// Delete Device
		deleteDevice(authToken, org){
			var self = this

            // Check if Device is selected
			if (self.curRowSelected==null){
				self.alert = "Device not selected."
				return
			}

			// Initialize device object
			var formData = new FormData();
			formData.append("deviceDocId", self.curRowSelected.deviceDocId);

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/DeleteDevice/',
					data: formData,
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if (response.data.err != ''){
						self.alert = response.data.err
					}
					else {
						// Refresh device list on the screen
						self.serverCall('getDevices')	
					}					
				})
				.catch(function (error) {
					self.deviceAlert = String(error)
				})
		},

	},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
